import { render, staticRenderFns } from "./SparksAreaCharts.vue?vue&type=template&id=01995f5a&scoped=true"
import script from "./SparksAreaCharts.vue?vue&type=script&lang=js"
export * from "./SparksAreaCharts.vue?vue&type=script&lang=js"
import style0 from "./SparksAreaCharts.vue?vue&type=style&index=0&id=01995f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01995f5a",
  null
  
)

export default component.exports